// Firebase Configuration for Identity Platform (GCIP)
// Uses environment variables to support different environments

import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence, Auth } from 'firebase/auth';

// Get environment-specific configuration
const env = process.env.REACT_APP_ENV || 'development';
const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || 
  (env === 'prod' ? 'sq-rewards-prod' : env === 'nonprod' ? 'sq-rewards-nonprod' : 'sq-rewards-nonprod');

// Firebase config - API key and other settings will be provided via environment variables
// For Identity Platform, we primarily need the project ID
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || `${projectId}.firebaseapp.com`,
  projectId: projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || `${projectId}.appspot.com`,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

// Initialize Firebase (only once)
const app: FirebaseApp = getApps().length === 0 
  ? initializeApp(firebaseConfig) 
  : getApps()[0]!;

// Initialize Auth
export const auth: Auth = getAuth(app);

// Set persistence to local (survives browser restarts)
if (typeof window !== 'undefined') {
  setPersistence(auth, browserLocalPersistence).catch((error: unknown) => {
    console.error('Failed to set auth persistence:', error);
  });
}

// Allowed email domains for internal access
export const ALLOWED_DOMAINS = ['sequel.ae', 'lore.co', 'lorehealthcare.com'];

export function isAllowedDomain(email: string): boolean {
  const domain = email.split('@')[1]?.toLowerCase();
  return ALLOWED_DOMAINS.includes(domain || '');
}

export default app;

